import { useNotificationContext } from '../context/NotificationContext';

// Re-export the context hook with a more intuitive name for components
export const useNotification = () => {
  return useNotificationContext();
};

// Export individual notification methods for convenience
export const useNotificationActions = () => {
  const { showSuccess, showError, showWarning, showInfo } = useNotificationContext();
  
  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};